import { d as MAX_ATTACHMENTS } from '../constants-BPNgncOf.js';

/**
 * Determines the effective attachment limit based on an optional input.
 *
 * If the provided number is between 1 and MAX_ATTACHMENTS (inclusive),
 * that number is returned. Otherwise (including when `num` is `null`,
 * `undefined`, or out of range), the fallback MAX_ATTACHMENTS is returned.
 *
 * @param {number} [num] - The desired number of attachments.
 * @returns {number} - A valid attachment limit between 1 and MAX_ATTACHMENTS.
 */
const getAttachmentLimit = num => num != null && num >= 1 && num <= MAX_ATTACHMENTS ? num : MAX_ATTACHMENTS;

export { getAttachmentLimit as g };
//# sourceMappingURL=getAttachmentLimit-C3TBgjYw.js.map
